<script setup lang="ts">
import { starkerMitbewerb } from '~/packages/commerce/texts/citations';

definePageMeta({
    isAuthRequired: false,
    layout: 'content',
});

const seoTitle = 'Starker Mitbewerb: Ihr Recruiting-Potenzial maximieren';
const seoDescription =
    'Schöpfen Sie Ihr volles Recruiting-Potenzial aus und behaupten Sie sich gegen den starken Mitbewerb. Jetzt mehr erfahren!';

useSeoMeta({
    description: seoDescription,
    ogDescription: seoDescription,
    ogTitle: seoTitle,
    title: seoTitle,
});

useRobotsRule(true);
</script>

<template>
    <div>
        <CommBaseContentContainer
            class="mt-10 flex flex-col gap-11 md:mt-16 md:gap-20"
        >
            <section class="grid grid-cols-3 justify-between gap-7">
                <div class="col-span-3 flex flex-col gap-6 lg:col-span-2">
                    <div class="flex flex-col gap-2">
                        <BaseHeading as="h1" variant="2xl-500">
                            Starker Mitbewerb
                        </BaseHeading>
                        <BaseText>
                            Schöpfen Sie Ihr volles Recruiting-Potenzial aus.
                        </BaseText>
                    </div>
                    <div class="flex flex-col gap-3">
                        <BaseText variant="base-500">
                            Der Arbeitsmarkt ist stark umkämpft: 91 Prozent der
                            österreichischen Arbeitgeber haben zumindest
                            teilweise Schwierigkeiten, offene Stellen
                            nachzubesetzen.
                            <CommBaseCitationLink :number="1" />
                        </BaseText>
                        <BaseText>
                            Qualifizierte Fachkräfte sind rar und
                            dementsprechend gefragt. Um sich gegen den Mitbewerb
                            zu behaupten und Talente zu gewinnen, ist das
                            Stelleninserat für sich allein nicht ausreichend.
                            Durch die Kombination unterschiedlicher
                            Recruiting-Maßnahmen erhöhen Arbeitgeber ihre
                            Erfolgschancen. karriere.at bietet diese Möglichkeit
                            - alles aus einer Hand.
                        </BaseText>
                    </div>
                </div>
            </section>
            <section class="grid grid-cols-3 justify-between gap-7">
                <div class="col-span-3 flex flex-col gap-2 lg:col-span-2">
                    <BaseHeading as="h2" variant="xl-500">
                        Unsere Produktkombination für Ihre Herausforderung
                    </BaseHeading>
                    <BaseText>
                        Machen Sie sich die breite Produktpalette von
                        karriere.at zunutze, um Ihr Recruiting-Potenzial
                        auszuschöpfen. Mit der Kombination aus Aktiver
                        Talentsuche, Stelleninseraten und Arbeitgeberprofil
                        decken Sie alle wichtigen Recruiting-Maßnahmen ab und
                        haben mit karriere.at einen Partner an Ihrer Seite, der
                        maximale Reichweite garantiert.
                    </BaseText>
                </div>
                <CommKhSectionTalentContacts :citation-number="2"  class="col-span-3"/>
            </section>
            <CommKhSectionJobAds :citation-numbers="[3,4]"/>
            <CommKhSectionEmployerProfilePlus />
            <MainCitations :citations="starkerMitbewerb" />
        </CommBaseContentContainer>
        <MainContact />
    </div>
</template>
